import { motion } from 'framer-motion';
import { FaPlay, FaClock, FaEye } from 'react-icons/fa';

const VideoCard = ({ video, onClick }) => {
  // YouTube thumbnail URL
  const thumbnailUrl = `https://img.youtube.com/vi/${video.youtubeId}/maxresdefault.jpg`;
  const thumbnailFallback = `https://img.youtube.com/vi/${video.youtubeId}/hqdefault.jpg`;

  const categoryColors = {
    stories: 'bg-blue-500',
    puzzles: 'bg-purple-500',
    activities: 'bg-orange-500',
    behindthescenes: 'bg-pink-500',
    tutorials: 'bg-green-500',
  };

  const categoryColor = categoryColors[video.category] || 'bg-primary-green';

  return (
    <motion.div
      whileHover={{ y: -8 }}
      onClick={onClick}
      className="card p-0 overflow-hidden cursor-pointer group hover:shadow-card-hover transition-all"
    >
      {/* Thumbnail Section */}
      <div className="relative aspect-video overflow-hidden">
        <img
          src={thumbnailUrl}
          alt={video.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
          onError={(e) => {
            e.target.src = thumbnailFallback;
          }}
          loading="lazy"
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors" />

        {/* Play Button */}
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          whileHover={{ scale: 1 }}
          className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-16 h-16 bg-[#FF0000] rounded-full flex items-center justify-center shadow-2xl opacity-0 group-hover:opacity-100 transition-opacity"
        >
          <FaPlay className="text-2xl text-white ml-1" />
        </motion.div>

        {/* Duration Badge */}
        {video.duration && (
          <div className="absolute bottom-2 right-2 bg-black/80 text-white text-xs font-bold px-2 py-1 rounded flex items-center gap-1">
            <FaClock className="text-xs" />
            {video.duration}
          </div>
        )}

        {/* Category Badge */}
        <div className={`absolute top-2 left-2 ${categoryColor} text-white text-xs font-display font-bold px-3 py-1 rounded-full capitalize`}>
          {video.category}
        </div>

        {/* Featured Badge */}
        {video.featured && (
          <div className="absolute top-2 right-2 bg-accent-yellow text-primary-green-dark text-xs font-display font-bold px-3 py-1 rounded-full">
            ⭐ Featured
          </div>
        )}
      </div>

      {/* Content Section */}
      <div className="p-4">
        {/* Title */}
        <h3 className="text-lg font-display font-bold text-primary-green-dark mb-2 line-clamp-2 group-hover:text-primary-green transition-colors">
          {video.title}
        </h3>

        {/* Description */}
        <p className="text-neutral-gray-dark text-sm line-clamp-2 mb-3">
          {video.description}
        </p>

        {/* Meta Info */}
        <div className="flex items-center justify-between text-xs text-neutral-gray-dark">
          {/* Views */}
          {video.views && (
            <div className="flex items-center gap-1">
              <FaEye />
              <span>{video.views} views</span>
            </div>
          )}

          {/* Date */}
          {video.publishedAt && (
            <div>
              {new Date(video.publishedAt).toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
              })}
            </div>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default VideoCard;